import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import PhproductshapeEditFormImpl from './PhproductshapeEditFormImpl';
import PhproductshapeList from './PhproductshapeList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import PhproductshapeListView from './PhproductshapeListView'


export default function PhproductshapeDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.phproductshapeDashboard);
  const [ phproductshapeId, setPhproductshapeId] = React.useState('');
  const [reloadPhproductshapeList, setReloadPhproductshapeList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <PhproductshapeEditFormImpl 
            setReloadPhproductshapeList={setReloadPhproductshapeList}
            phproductshapeId={phproductshapeId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <PhproductshapeListView 
                      setPhproductshapeId = {setPhproductshapeId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
